<template>
  <div
    class="relative"
    :class="[
      SSectionVerticalMarginClasses,
      SSectionBackgroundColorsClasses[backgroundColor],
    ]"
  >
    <TContainer>
      <TGrid>
        <div class="col-span-12" :class="SSectionverticalPaddingClasses">
          <TTitle
            v-if="title && title.length > 0"
            :tag="titleTag"
            :size="SSectionTitleSize"
            class="text-center"
            :class="SSectionTextColorsClasses[backgroundColor]"
            :classes="SSectionTitleClasses"
            :leading="SSectionTitleLeading"
          >
            {{ title }}
          </TTitle>

          <slot />
        </div>
      </TGrid>
    </TContainer>
  </div>
</template>

<script setup lang="ts">
import type { propsInterface as TTitlePropsInterface } from '~~/modules/design-system/components/t-title/index.vue'
import type { SSectionBackgroundColorsProp } from './constants'
import {
  SSectionVerticalMarginClasses,
  SSectionverticalPaddingClasses,
  SSectionBackgroundColorsClasses,
  SSectionTextColorsClasses,
  SSectionBackgroundColor,
} from './constants'
import { sectionTitle } from '~~/modules/design-system/utils/components/t-title'

const SSectionTitleSize = sectionTitle.size
const SSectionTitleClasses = sectionTitle.classes
const SSectionTitleLeading = sectionTitle.leading

export interface propsInterface {
  title?: string
  titleTag?: TTitlePropsInterface['tag']
  backgroundColor?: SSectionBackgroundColorsProp
}

withDefaults(defineProps<propsInterface>(), {
  titleTag: sectionTitle.tag,
  backgroundColor: SSectionBackgroundColor,
})
</script>
